module.exports = __webpack_public_path__ + "img/1482552018.587fc006.jpg";